import React from "react";
import * as router from "react-router-dom";



import Login from "./Business/Login/LoginIndex.js";
import AccessDenied from "./Business/Login/AccessDenied.js";
import Dashboard from "./Business/Login/DashboardIndex.js";
import Role from "./Business/User/RoleIndex.js";
import ProvinceCity from "./Business/ProvinceCity/ProvinceCityIndex.js";
import User from "./Business/User/UserIndex.js";
import ProductGroup from "./Business/ProductGroup/ProductGroupIndex.js";
import Brand from "./Business/ProductBrand/BrandIndex.js";
import Product from "./Business/Product/ProductIndex.js";
import FiscalYear from "./Business/FiscalYear/FiscalYearIndex.js";
import StoreRoom from "./Business/StoreRoom/StoreRoomIndex.js";
import Reciept from "./Business/StoreRoomReciept/RecieptIndex.js";
import FirstPeriodReciept from "./Business/StoreRoomReciept/FirstPeriodRecieptIndex.js";
import InsertReciept from "./Business/StoreRoomReciept/InsertRecieptIndex.js";
import InsertFirstPeriodReciept from "./Business/StoreRoomReciept/InsertFirstPeriodRecieptIndex.js";
import PrintReciept from "./Business/StoreRoomReciept/PrintRecieptindex.js";
// import Transfer from "./Business/StoreRoomTransfer/TransferIndex.js";
import SaleTransfer from "./Business/StoreRoomTransfer/SaleTransferIndex.js";
import BasketTransfer from "./Business/StoreRoomTransfer/BasketTransferIndex.js";
import InsertTransfer from "./Business/StoreRoomTransfer/InsertTransferIndex.js";
import PrintTransfer from "./Business/StoreRoomTransfer/PrintTransferIndex.js";
import CardexCountReport from "./Business/CardexReport/CardexCountReportIndex.js";
import StorRoomInventoryExist from "./Business/StoreRoom/StorRoomInventoryExistIndex.js";
import BuyOrder from "./Business/BuyOrder/BuyOrderIndex.js";
import InsertBuyOrder from "./Business/BuyOrder/InsertBuyOrderIndex.js";
import PrintBuyOrder from "./Business/BuyOrder/PrintBuyOrderIndex.js";
import Discount from "./Business/Discount/DiscountIndex.js";
import InsertDiscount from "./Business/Discount/InsertDiscountIndex.js";
import ProductPrice from "./Business/ProductPrice/ProductPriceIndex.js";
import ProductPricePercent from "./Business/ProductPrice/ProductPricePercentIndex.js";
import SalesSituation from "./Business/Product/SalesSituationIndex.js";
import SuggestionProduct from "./Business/SuggestionProduct/SuggestionProductIndex.js";
import PreFactor from "./Business/PreFactor/PreFactorIndex.js";
import PrintPreFactor from "./Business/PreFactor/PrintPreFactorIndex.js";
import InsertPreFactor from "./Business/PreFactor/InsertPreFactorIndex.js";
import PreReciept from "./Business/PreFactor/PreRecieptIndex.js";
import Factor from "./Business/Factor/FactorIndex.js";
import InsertFactor from "./Business/Factor/InsertFactorIndex.js";
import InsertFacorReciept from "./Business/Factor/InsertRecieptIndex.js";
import PrintFactor from "./Business/Factor/PrintfactorIndex.js";

import Bank from "./Business/Bank/BankIndex.js";
import Fund from "./Business/Fund/FundIndex.js";
import AccountDetail from "./Business/AccountDetail/AccountDetailIndex.js";
import DOCSettings from "./Business/AccountDocSettings/DocSettingsIndex.js";
import UserConfig from "./Business/Config/UserConfigIndex.js";
import DocType from "./Business/AccountDocType/DocTypeIndex.js";
import DocIndex from "./Business/AccountDoc/DocIndex.js";
import InsertDocIndex from "./Business/AccountDoc/InsertDocIndex.js";
import GeneralLedgerReportIndex from "./Business/AccountReport/GeneralLedgerReportIndex.js";
import ControlReportIndex from "./Business/AccountReport/ControlReportIndex.js";
import DayReportIndex from "./Business/AccountReport/DayReportIndex.js";
import PaymentReceived from "./Business/PaymentReceived/PaymentReceivedIndex.js";
import InsertPaymentReceived from "./Business/PaymentReceived/InsertPaymentReceivedIndex.js";
import PrintPaymentReceived from "./Business/PaymentReceived/PrintPaymentReceivedIndex.js";
import InventoryCounting from "./Business/InventoryCounting/InventoryCountingIndex.js";
import InsertInventoryCounting from "./Business/InventoryCounting/InsertInventoryCountingIndex.js";
import Basket from "./Business/Basket/BasketIndex.js";



function App() {
  // const navigate = router.useNavigate();
  return (
    <router.BrowserRouter>
      <router.Routes>
        <router.Route path="/" element={<Login></Login>} />
        <router.Route path="/Dashboard" element={<Dashboard ></Dashboard>} />
        <router.Route path="/AccessDenied" element={<AccessDenied></AccessDenied>} />
        <router.Route path="/Role" element={<Role></Role>} />
        <router.Route path="/ProvinceCity" element={<ProvinceCity></ProvinceCity>} />
        <router.Route path="/User" element={<User></User>} />
        <router.Route path="/ProductGroup" element={<ProductGroup></ProductGroup>} />
        <router.Route path="/Brand" element={<Brand></Brand>} />
        <router.Route path="/Product" element={<Product></Product>} />
        <router.Route path="/StoreRoom" element={<StoreRoom></StoreRoom>} />
        <router.Route path="/FiscalYear" element={<FiscalYear></FiscalYear>} />
        <router.Route path="/Reciept" element={<Reciept></Reciept>} />
        <router.Route path="/InsertReciept" element={<InsertReciept></InsertReciept>} />
        <router.Route path="/FirstPeriodReciept" element={<FirstPeriodReciept></FirstPeriodReciept>} />
        <router.Route path="/InsertFirstPeriodReciept" element={<InsertFirstPeriodReciept></InsertFirstPeriodReciept>} />
        <router.Route path="/PrintReciept" element={<PrintReciept></PrintReciept>} />
        {/* <router.Route path="/Transfer" element={<Transfer></Transfer>} /> */}
        <router.Route path="/SaleTransfer" element={<SaleTransfer></SaleTransfer>} />
        <router.Route path="/BasketTransfer" element={<BasketTransfer></BasketTransfer>} />
        <router.Route path="/InsertTransfer" element={<InsertTransfer></InsertTransfer>} />
        <router.Route path="/PrintTransfer" element={<PrintTransfer></PrintTransfer>} />
        <router.Route path="/CardexCountReport" element={<CardexCountReport></CardexCountReport>} />
        <router.Route path="/StorRoomInventoryExist" element={<StorRoomInventoryExist></StorRoomInventoryExist>} />
        <router.Route path="/BuyOrder" element={<BuyOrder></BuyOrder>} />
        <router.Route path="/InsertBuyOrder" element={<InsertBuyOrder></InsertBuyOrder>} />
        <router.Route path="/PrintBuyOrder" element={<PrintBuyOrder></PrintBuyOrder>} />
        <router.Route path="/Discount" element={<Discount></Discount>} />
        <router.Route path="/InsertDiscount" element={<InsertDiscount></InsertDiscount>} />
        <router.Route path="/ProductPrice" element={<ProductPrice></ProductPrice>} />
        <router.Route path="/ProductPricePercent" element={<ProductPricePercent></ProductPricePercent>} />
        <router.Route path="/SalesSituation" element={<SalesSituation></SalesSituation>} />
        <router.Route path="/SuggestionProduct" element={<SuggestionProduct></SuggestionProduct>} />
        <router.Route path="/PreFactor" element={<PreFactor></PreFactor>} />
        <router.Route path="/PrintPreFactor" element={<PrintPreFactor></PrintPreFactor>} />
        <router.Route path="/InsertPreFactor" element={<InsertPreFactor></InsertPreFactor>} />
        <router.Route path="/Factor" element={<Factor></Factor>} />
        <router.Route path="/PrintFactor" element={<PrintFactor></PrintFactor>} />
        <router.Route path="/InsertFactor" element={<InsertFactor></InsertFactor>} />
        <router.Route path="/InsertFacorReciept" element={<InsertFacorReciept></InsertFacorReciept>} />
        <router.Route path="/PreReciept" element={<PreReciept></PreReciept>} />
        <router.Route path="/Bank" element={<Bank></Bank>} />
        <router.Route path="/Fund" element={<Fund></Fund>} />
        <router.Route path="/AccountDetail" element={<AccountDetail></AccountDetail>} />
        <router.Route path="/DOCSettings" element={<DOCSettings></DOCSettings>} />
        <router.Route path="/UserConfig" element={<UserConfig></UserConfig>} />
        <router.Route path="/DocType" element={<DocType></DocType>} />
        <router.Route path="/DocIndex" element={<DocIndex></DocIndex>} />
        <router.Route path="/InsertDoc" element={<InsertDocIndex></InsertDocIndex>} />
        <router.Route path="/GeneralLedgerRepor" element={<GeneralLedgerReportIndex></GeneralLedgerReportIndex>} />
        <router.Route path="/ControlReport" element={<ControlReportIndex></ControlReportIndex>} />
        <router.Route path="/DayReport" element={<DayReportIndex></DayReportIndex>} />
        <router.Route path="/PaymentReceived" element={<PaymentReceived></PaymentReceived>} />
        <router.Route path="/InsertPaymentReceived" element={<InsertPaymentReceived></InsertPaymentReceived>} />
        <router.Route path="/PrintPaymentReceived" element={<PrintPaymentReceived></PrintPaymentReceived>} />
        <router.Route path="/InventoryCounting" element={<InventoryCounting></InventoryCounting>} />
        <router.Route path="/InsertInventoryCounting" element={<InsertInventoryCounting></InsertInventoryCounting>} />
        <router.Route path="/Basket" element={<Basket></Basket>} />


      </router.Routes>
    </router.BrowserRouter>

  )

}


export default App;